/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import AssetStatusDropdown from 'domain/finance/assets/shared/input/AssetStatusDropdown';

const AssetStatusDropdownFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <AssetStatusDropdown {...props} />
    </DropDownFilter>
  );
};

export default AssetStatusDropdownFilter;
